import { render } from "./dewas-list.vue?vue&type=template&id=d432535a"
import script from "./dewas-list.vue?vue&type=script&lang=js"
export * from "./dewas-list.vue?vue&type=script&lang=js"

import "./dewas-list.vue?vue&type=style&index=0&id=d432535a&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__